import { useMemo } from "react";
import GoogleMapReact from "google-map-react";

import { SEGMENT_COLORS } from "./QuantityChart";
import { LocationIcon } from "../../../components/map/LocationIcon";
import { COLORS } from "../../../theme/colors";

export const DEFAULT_CENTER = { lat: 53.399229999999996, lng: -2.6992925 };

export const BuildingsMap = ({ buildings, height }) => {
  const validAddressBuildings = buildings?.filter((b) => b.lat && b.lng);
  const center = useMemo(() => {
    if (!validAddressBuildings?.length) return undefined;
    let sumLat = 0;
    let sumLng = 0;
    for (const property of validAddressBuildings) {
      sumLat += property.lat;
      sumLng += property.lng;
    }
    return {
      lat: sumLat / buildings.length,
      lng: sumLng / buildings.length,
    };
  }, [validAddressBuildings]);

  return (
    <div style={{ height: height, width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
        defaultCenter={DEFAULT_CENTER}
        center={center}
        defaultZoom={3}
      >
        {validAddressBuildings?.map((building, index) => (
          <LocationIcon
            key={index}
            lat={building.lat}
            lng={building.lng}
            color={
              SEGMENT_COLORS[building.segment?.toLowerCase()?.replace("-", "_")] || COLORS.purple
            }
            style={{ position: "relative", top: -42, left: -16 }}
          />
        ))}
      </GoogleMapReact>
    </div>
  );
};
